import {
  Box,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import CommonService from "services/CommonService";
import RoleService from "services/RoleService";
import { AuthData } from "auth/AuthWarpper";
import { useNavigate } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import ManageRoles from "assets/ManageRoles.svg";
import ManageUsers from "assets/ManageUsers.svg";
// import AssignFunctionality from "assets/user-access/AssignFunctionality.svg";
import Reports from "assets/Reports.svg";
import AgriUserReport from "assets/AgriUserReport.svg";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
const RoleScreen = () => {
  const profileOptions = ["Global", "Local"];
  const { user } = AuthData();
  const navigate = useNavigate();
  const { setOpenAlert, setSeverity, setMessage, handleClose } =
    useContext(SnackbarContext);

  const [formData, setFormData] = useState({
    profile: "",
    fieldTechnician: "",
    role: "",
    country: "",
    serviceNumber: "",
    remarks: "",
  });
  const [selected, setSelected] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = React.useState(false);

  const [roleOptions, setRoleOptions] = useState([]);
  const [countries, setCountries] = useState([]);

  const fetchRoles = async () => {
    try {
      const response = await RoleService.getActiveRoles();
      if (response.data?.statusCode === 200) {
        setRoleOptions(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await CommonService.fetchCountries();
      if (response.data?.statusCode === 200) {
        setCountries(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  useEffect(() => {
    fetchRoles();
    fetchCountries();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const isAllSelected =
    countries.length > 0 && selected.length === countries.length;

  const handleChangeCountry = (event) => {
    const option = event.target.value;

    if (option[option.length - 1] === "all") {
      setSelected(selected.length === countries.length ? [] : countries);
      // Update formData to reflect selected or deselected countries
      setFormData((prevFormData) => ({
        ...prevFormData,
        cropStageCountryDetail:
          selected.length === countries.length ? [] : countries,
      }));
      return;
    }

    setSelected(option);
    setFormData((prevFormData) => ({
      ...prevFormData,
      cropStageCountryDetail: option,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setLoading(true);
    try {
      // setErrors({});
      // await validationSchema.validate(formData, { abortEarly: false });

      // Constructing the payload object
      const payload = {
        profileName: formData.fieldTechnician,
        isActive: true,
        profileAttribute: formData.profile,
        serviceNumber: formData.serviceNumber,
        remarks: formData.remarks,
        isDeleted: false,
        profileOwnerId: formData.role,
        systemOwner: user?.batOneId,
        countries: selected.map((country) => ({
          createdByUser: user?.userName || "Raju",
          modifiedByUser: user?.userName || "Raju",
          countryCode: country.countryCode,
          isDeleted: false,
          createdDateTimeUTC: new Date().toISOString(),
          modifiedDateTimeUTC: new Date().toISOString(),
        })),
        createdByUser: user.userName,
        modifiedByUser: user.userName,
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),
      };

      // Make a POST request using Axios
      const response = await RoleService.createRole(payload);

      if (response.status === 201) {
        // Show success snackbar
        navigate("/roleCreation");
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
        setLoading(false);
      } else {
        console.error("Failed to submit form");
        // Show error snackbar
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
      setLoading(false);
    }
  };

  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "25px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "80vh",
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
            borderRadius: "6px",
            gap: "60px",
          }}
        > 
          {!user?.profiles?.some(profile => ["SoX Report_Global User","SoX Report_Local User"].some(role => 
            role.toLowerCase() === profile.profileName.toLowerCase()
          )) && (
          <>
          <Box
          onClick={() => user?.profiles?.some(profile => profile.profileName === 'IT Admin Access Mgt') ? navigate('/userCreation'):navigate('/administratorUserList')}
            sx={{
              background: "#ffffff",
             width: "275.26px",
              height: "368px",
              p: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
              borderRadius: "16px",
              transition: "box-shadow 0.3s ease-in-out",
              "&:hover": {
                boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
              },
              cursor:"pointer"

            }}
          >
            <img
              src={ManageUsers}
              style={{ width: "82.41px", height: "92.48px" }}
              alt="List Logo"
            />
            <Typography
              sx={{ fontWeight: 600, fontSize: "30px", color: "#0A3575" , textAlign:"center",
            }}
            >
              Manage Users
            </Typography>
          </Box>
          <Box
          onClick={() => user?.profiles?.some(profile => profile.profileName === 'IT Admin Access Mgt') ? navigate('/roleCreation'):navigate('/administratorCReation')}
            sx={{
              background: "#ffffff",
             width: "275.26px",
              height: "368px",
              p: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
              borderRadius: "16px",
              transition: "box-shadow 0.3s ease-in-out",
              "&:hover": {
                boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
              },
              cursor:"pointer"
            }}
          >
            <img
              src={ManageRoles}
              style={{ width: "82.41px", height: "92.48px" }}
              alt="List Logo"
            />
            <Typography
              sx={{ fontWeight: 600, fontSize: "30px", color: "#0A3575",  textAlign:"center", }}
            >
              Manage Roles
            </Typography>
          </Box>
          </>
          )}
          {user?.profiles?.some(profile => 
            ["IT Admin Access Mgt", "SoX Report_Global User", "SoX Report_Local User"].some(role => 
              role.toLowerCase() === profile.profileName.toLowerCase()
            )
          ) && (
            <Box
            onClick={() => navigate('/getReports')}
              sx={{
                background: "#ffffff",
               width: "275.26px",
                height: "368px",
                p: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px",
                borderRadius: "16px",
                transition: "box-shadow 0.3s ease-in-out",
                "&:hover": {
                  boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                },
                cursor:"pointer"
              }}
            >
              <img
                src={Reports}
                style={{ width: "82.41px", height: "92.48px" }}
                alt="List Logo"
              />
              <Typography
                sx={{ fontWeight: 600, fontSize: "30px", color: "#0A3575", textAlign:"center", }}
              >
                Reports &nbsp; &nbsp; &nbsp; 
              </Typography>
            </Box>
          )}
          {user?.profiles?.some(profile => 
            ["IT Admin Access Mgt"].some(role => 
              role.toLowerCase() === profile.profileName.toLowerCase()
            )
          ) && (
            <Box
            onClick={() => navigate('/readOnlyUserMapping')}
              sx={{
                background: "#ffffff",
               width: "275.26px",
                height: "368px",
                p: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px",
                borderRadius: "16px",
                transition: "box-shadow 0.3s ease-in-out",
                "&:hover": {
                  boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                },
                cursor:"pointer"
              }}
            >
              <img
                src={Reports}
                style={{ width: "82.41px", height: "92.48px" }}
                alt="List Logo"
              />
              <Typography
                sx={{ fontWeight: 600, fontSize: "30px", color: "#0A3575", textAlign:"center", }}
              >
                Read Only User Mapping
              </Typography>
            </Box>
          )}
          
         


          
        </Box>
      </Box>
    </LayoutAccessManagement>
  );
};

export default RoleScreen;
